import React from 'react';
import { energyScanning } from '../data/mock';
import { Camera, Search, Heart } from 'lucide-react';

const ScanningSection = () => {
  const icons = [Camera, Search, Heart];

  return (
    <section id="scanning" className="py-24 lg:py-32 bg-[#FFFEF8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          {/* Content */}
          <div>
            <p className="text-sm tracking-[0.2em] text-[#6B8F71] mb-4 uppercase">
              {energyScanning.subtitle}
            </p>
            
            <h2 className="text-3xl lg:text-4xl font-light text-[#333333] mb-6">
              {energyScanning.title}
            </h2>
            
            <p className="text-base text-[#666666] leading-relaxed mb-12">
              {energyScanning.description}
            </p>

            {/* Process Steps */}
            <div className="space-y-8">
              {energyScanning.process.map((step, index) => {
                const Icon = icons[index];
                return (
                  <div key={step.step} className="flex gap-6">
                    <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center bg-[#F8F7F2]">
                      <Icon className="w-5 h-5 text-[#6B8F71]" />
                    </div>
                    <div>
                      <h4 className="text-lg font-normal text-[#333333] mb-2">
                        {step.title}
                      </h4>
                      <p className="text-sm text-[#666666] leading-relaxed">
                        {step.description}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Image */}
          <div className="relative lg:sticky lg:top-32">
            <img
              src={energyScanning.image}
              alt="Crystal formations"
              className="w-full h-[400px] lg:h-[500px] object-cover"
            />
            <div className="absolute -top-4 -right-4 w-24 h-24 border border-[#B8A88A]/30" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScanningSection;
